<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_qiug" v-loading="loading">
            <div class="qiug_tit">
                <p>供应详情</p>
            </div>
            <!--...报价信息...-->
            <ul class="gyx">
                    <li>
                        <div class="sh">
                            <div class="z">
                                <div class="tu" v-if="model.image">
                                    <img :src="$util.img(model.image)" alt="">
                                </div>
                                <div class="zi">
                                    <h2>{{model.categoryname}}  {{model.attr_value_name}}</h2>
                                    <h3> <span>{{model.price}}</span>{{model.unit}}</h3>
                                    <p>所在地：{{model.areaname}}</p>
                                </div>
                            </div>
                            <div class="y">
                                <p>{{ $util.timeStampTurnTime(model.createtime, 'YYYY-MM-DD') }}</p>
                                <img v-if="model.isshow == 1 && model.state == 1" src="@/assets/styles/picture/me_img03.png"/>
                                <img v-if="model.isshow == 1 && model.state == 0" src="@/assets/styles/picture/me_img22.png"/>
                                <img v-if="model.isshow == 1 && model.state == -1" src="@/assets/styles/picture/me_img21.png"/>
                                <img v-if="model.isshow == 0" src="@/assets/styles/picture/me_img01.png"/>
                            </div>
                        </div>
                        <div class="xia" style="word-break: break-all;">
                            <span>商品描述：</span>
                            {{model.remark}}
                        </div>
                    </li>
            </ul>
        </div>
    </div>
</template>

<style scoped>
    .gyx{width: 100%;margin: auto}
    .gyx li{width: 96%;background: #f5f5f5;border-radius: 10px;padding: 2%;margin-bottom: 20px;}
    .gyx li:hover{background: #fff;box-shadow: 0 2px 14px #e8e8e8;}
    .gyx li .sh{width: 100%;display: flex;flex-direction: row;justify-content: space-between;align-items: center} 
    .gyx li .sh .z{width: 60%;display: flex;flex-direction: row;justify-content: flex-start;align-items: center}
    .gyx li .sh .z .tu{width: 100px;height: 100px;border-radius: 10px;overflow: hidden;margin-right: 12px;}
    .gyx li .sh .z .tu img{width: 100%;height: 100%;}
    .gyx li .sh .z .zi h2{font-size: 16px;color: #333}
    .gyx li .sh .z .zi h3{margin: 10px 0;font-size: 14px;color: #d60000;font-weight: normal}
    .gyx li .sh .z .zi h3 span{font-size: 20px;font-family: Bahnschrift;margin-right: 2px;font-weight: bold}
    .gyx li .sh .y p{font-size: 16px;font-family: Bahnschrift;color: #999;margin-bottom: 20px;}
    .gyx li .sh .y img{width: 60px;height: 60px;} 
    .gyx li .xia{margin-top: 10px;font-size: 14px;color: #666;line-height: 24px;}
</style>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import '@/assets/styles/css/iconfont.css';
    import { supplyDetail } from '@/api/supply/supply';
    import util from '@/utils/util.js';

    export default {
        name: "",
        data: () => {
            return {
                priceList:[],
                loading:true,
                id:0,
                model:{},
                count:'',
                statename:'',
                shopInfo:{},
            }
        },
        created() {
           this.id = this.$route.query.id;
           this.getDetails();
        },
        methods: {
            getDetails() {
                supplyDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        if(this.model.isshow == 0) {
                            this.statename = '已下架';
                        }
                        else {
                            this.statename = this.model.state == 1 ? '采购中' : (this.model.state == 0 ? '审核中' : '已驳回');
                        }
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                })
            },
        },
        mounted() {

		},
    }
</script>